"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OFFSET_DISTANCE = void 0;
exports.OFFSET_DISTANCE = 0.0001; // ~11 meters at equator;
//# sourceMappingURL=constants.js.map